import axios from 'axios'
import { useCookies } from '@vueuse/integrations/useCookies'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { get, includes } from 'lodash'
import axiosRetry from 'axios-retry'
import ENV from '@/constants/env'
import { COOKIE_OPTIONS } from '@/constants/cookies'
import { getCookieDomain } from '@helm/functions/amplify'

const helmHost = ENV.helmHost
const cookies = useCookies()

const axiosInstance = axios.create({ baseURL: helmHost })

axiosRetry(axiosInstance, { retries: 2, retryCondition: error => error.response?.status === 502 })

axiosInstance.interceptors.request.use(config => {
    const token = cookies.get(`helm_access_token`)

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
        config.headers[`Content-Type`] = `application/json`
    }

    return config
})

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (includes([417, 418], error.response?.status)) {
            window.location.replace('/logout')
        }

        return Promise.reject(error)
    }
)

const refreshAuthLogic = (failedRequest: any): Promise<any> => {
    const accessToken = cookies.get(`helm_access_token`)

    if (!accessToken) {
        if (window.location.pathname !== `/login`) {
            window.location.replace('/login')
        }
        return Promise.reject()
    }

    return axios({
        method: `POST`,
        url: `${helmHost}/auth/refresh`,
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    })
        .then((response: any) => {
            const newAccessToken = get(response, `data.access_token`)

            if (!newAccessToken) {
                return Promise.reject()
            }

            cookies.set(`helm_access_token`, newAccessToken, {
                ...COOKIE_OPTIONS,
                domain: getCookieDomain()
            })

            failedRequest.response.config.headers['Authorization'] = `Bearer ${newAccessToken}`
            return Promise.resolve()
        })
        .catch(() => {
            window.location.replace('/logout')
            return Promise.reject()
        })
}

createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic)

export default axiosInstance
